import React, { Suspense } from 'react';
import BaseLayout from '../../../Molecules/CustomSection/SingleFormLayout/index';

const EmployeeData = (props) => {
  return (
    <div>
      <Suspense fallback={<div>Loading...</div>}>
        {/*  <MessageComponent /> */}
        <div className="formWrapper">
          <BaseLayout formLayoutType={'EmployeeData'} formName={'EmployeeData'}/>
        </div>
      </Suspense>
    </div>
  );
};

export default EmployeeData;
